export function nonZeroRenderer(param: { value?: any }) {
  const value = param.value;

  if (parseInt(value) === 0) {
    return '';
  }

  return value;
}
